import SmashSpinner from '../../../components/SmashSpinner/SmashSpinner';
import SmashTable from '../../../components/SmashTable/SmashTable';
import { TableHeaders } from '../../../components/SmashTable/SmashTableHead';
import { useTransfer } from '../hooks/useTransfer';
import { TableActionItem } from '../../../components/SmashTable/SmashTableAction';
import ConfirmDeleteTransferModal from './ConfirmDeleteTransferModal';
import TransferSdk from "@smash-sdk/transfer/ejs/07-2022";
import TransferStatus from './TransferStatus';

const ListTransfer = () => {
    const [isLoading, transfers, previous, next] = useTransfer();

    const headers: TableHeaders[] = [{
        label: 'Date',
        type: 'date',
        accessor: 'created',
        sortable: true,
        sortbyOrder: "desc"
    }, {
        label: 'Transfer ID',
        accessor: 'id',
        sortable: false,
    }, {
        label: 'Status',
        accessor: 'status',
        sortable: false,
        
    }, {
        label: 'Transfer size',
        accessor: 'size',
        type: 'bytes',
        sortable: false,
    }, {
        label: 'Downloads',
        accessor: 'transferDownloads',        
        sortable: false,
        
    }];

    const renderers: any = {
        status: (item: TransferSdk.GetTransferOutput['transfer']) => <TransferStatus status={item.status} />
    }

    const actions: TableActionItem[] = [{
        name: 'details',
        url: (item) => "/transfers/" + item.id,
        actionComponent: (props) => <span>Details</span>,
       }, {
        name: 'delete',
        actionComponent: (props) => props.item.status === 'Uploaded' && <ConfirmDeleteTransferModal item={props.item}>Delete</ConfirmDeleteTransferModal>,
    }]

    return (
        <SmashTable 
            loading={isLoading} 
            headers={headers} 
            tableActions={actions}
            onRowClick={'id'}
            customRenderers={renderers}
            items={transfers} 
            textFallback={'No transfer'} 
            />
    )

}

export default ListTransfer